export default __webpack_public_path__ + "static/credits_song-80c40519a477c0e9af08e0085b95b390.mp3";